<template>
    <div class="text-input">
        <div @click="closeList()" v-if="open" class="dropdown-background"></div>
        <label><b>{{label}}</b></label>
        <div class="input-group border">
          <div @click="openList()" class="thumbnail-wrapper">
              <img :src="currentConfigurator.ConfiguratorLogoUrl" class="image" :alt="currentConfigurator.ConfiguratorName">
              <i  class="fa fa-angle-down icon-dropdown"  aria-hidden="true"></i>
          </div>
            <!-- <input class="form-control pr-4"
                    :placeholder="placeholder"
                    v-model="displayValue"
                    @focus="openList()"
                    ref="repSelect"
                    :disabled="disabled"
                    :aria-label="{label}"/> -->
                    
                 
            <div v-if="open" class="rep-list-card card">
                <ul class="p-0 m-0">
                    <div class="pointer rep-list" v-for="configurator in configurators" :key="configurator.Id" @click="updateValue(configurator)">
                      <img :src="configurator.ConfiguratorLogoUrl" width="300" height="100">
                    </div>
                </ul>
            </div>
            <!-- <i class="fa fa-chevron-down"></i> -->
        </div>
    </div>
</template>

<script>
    import logo from '@/assets/SmartSalesLogo.png'
    export default {
        name: "LogoDropdown",
        props: {
            configurators: {
                type: Array,
            },
            label: {
                type: String,
            },
            placeholder: {
                type: String,
            },
            value: {
                type: Number,
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },

        data(){
            return {
              defaultConfigurator:{
                Id: null,
                ConfiguratorName: "DentaCAD Default",
                ConfiguratorLogoUrl: logo,
              },
              currentConfigurator: null,
              open: false
            }
        },  
        methods: {
            
            openList(){
                // this.currentConfigurator = {
                //   configuratorName = "",
                //   thumbnailUrl = null
                // }
                
                this.open = true;
            },
            closeList(){
                // this.displayValue = this.getSalesRepFullName(this.value)
                this.open = false;
            },
            updateValue(Configurator){
                this.currentConfigurator = Configurator;
                this.$emit('input', Configurator.Id);
                this.$emit('change')
                this.closeList()
            },
            getCurrentConfigurator(){
              if(!this.value) return this.defaultConfigurator;
              let index = this.configurators.map(config => config.Id).indexOf(this.value);
              return this.configurators[index]
            }
        },
        watch:{
            value: function(){
                this.currentConfigurator = this.getCurrentConfigurator();
            },
        },
        // computed: {
        //     configuratorOptions(){
        //         let repOptions = this.salesReps.filter(rep => {
        //             let fullName = rep.FirstName + " " + rep.LastName;
        //             fullName = fullName.toLowerCase()
        //             return fullName.includes(this.displayValue.toLowerCase())
        //         })
        //         return repOptions.sort(function(a, b) {
        //             var textA = a.FirstName.toUpperCase();
        //             var textB = b.FirstName.toUpperCase();
        //             return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        //         });
        //     }
        // },
        created(){
            this.currentConfigurator = this.getCurrentConfigurator();
        }
    }
</script>

<style scoped lang="scss">
    .image{
        max-width: 400px;
        max-height: 100px;
    }
    .thumbnail-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        min-height: 100px;
        width: 100%;
    }
    .icon-dropdown{
        display: flex;
        margin-left: 10px;
        justify-content: center;
        max-width: 50px;
        height: 100%;
        font-size: 30px;
        align-items: center;
    }
    .rep-list-card{
        z-index: 15;
        margin-top: 0px;
        border: solid 1px $primary;
        position: absolute;
        max-height: 600px;
        overflow: scroll;
        width: -webkit-fill-available;
        
    }
    .rep-list{
        border-bottom: solid .5px grey;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 20;
        padding: 5px;
        &:hover {
            background-color: $ss-blue-light;
            color: black;
        }
    }
    .dropdown-background{
        position: fixed;
        min-width: 100%;
        min-height: 100%;
        z-index: 10;
        left: 0; 
        top: 0;
        }
    .form-group{
        margin-bottom: 0px;
        select {
            -webkit-appearance: none;
            -moz-appearance: none;
            -o-appearance: none;
            /* no standardized syntax available, no ie-friendly solution available */
        }
        select + i.fa {
            float: right;
            margin-top: -26px;
            margin-right: 5px;
            /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
            pointer-events: none;
            background: inherit;
            /* everything after this is just to cover up the original arrow */
            /* (for browsers that don't support the syntax used above) */
            padding-right: 5px;
        }
    }
</style>